/* eslint-disable no-console */
import { ref } from 'vue';
const singl_coreImports = {
    showError: (error) => {
        console.error('Micro Front Core Imports - showError not implemented', error);
    },
    useAsyncData: () => {
        console.warn('Micro Front Core Imports - useAsyncData not implemented');
        return { data: null, error: null, status: {}, pending: ref(false) };
    },
    useHead: () => {
        console.warn('Micro Front Core Imports - useHead not implemented');
    },
    useHeadSafe: () => {
        console.warn('Micro Front Core Imports - useHeadSafe not implemented');
    },
    useRequestHeader: (args) => {
        console.warn('Micro Front Core Imports - useRequestHeader not implemented');
        return {
            [args || '']: '',
        };
    },
    useNuxtApp: () => {
        console.warn('Micro Front Core Imports - useNuxtApp not implemented');
        return {};
    },
    useNuxtData: () => {
        console.warn('Micro Front Core Imports - useNuxtData not implemented');
        return {};
    },
};
export function setCoreFunctions(coreFunctions) {
    singl_coreImports.showError = coreFunctions.showError || singl_coreImports.showError;
    singl_coreImports.useAsyncData = coreFunctions.useAsyncData || singl_coreImports.useAsyncData;
    singl_coreImports.useHead = coreFunctions.useHead || singl_coreImports.useHead;
    singl_coreImports.useHeadSafe = coreFunctions.useHeadSafe || singl_coreImports.useHeadSafe;
    singl_coreImports.useRequestHeader = coreFunctions.useRequestHeader || singl_coreImports.useRequestHeader;
    singl_coreImports.useNuxtApp = coreFunctions.useNuxtApp || singl_coreImports.useNuxtApp;
    singl_coreImports.useNuxtData = coreFunctions.useNuxtData || singl_coreImports.useNuxtData;
}
export function useCoreImports() {
    return singl_coreImports;
}
//# sourceMappingURL=core-imports.js.map